export const MAX_NUMBER_OF_IMAGES = 3;
export const MAX_NUMBER_OF_COLORS = 2;
export const MAX_NUMBER_OF_KEYWORDS = 3;
export const MAX_NUMBER_OF_MATERIALS = 2;

export const DESCRIPTION_LIST = [
  '',
  `마음에 드는 이미지를 ${MAX_NUMBER_OF_IMAGES}개 선택해주세요`,
  `선호하는 컬러를 ${MAX_NUMBER_OF_COLORS}개 선택해 주세요`,
  `선호하는 키워드를 ${MAX_NUMBER_OF_KEYWORDS}개 선택해주세요`,
  `좋아하는 소재를 ${MAX_NUMBER_OF_MATERIALS}개 선택해주세요`,
];
